import React, { useEffect } from 'react'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import Form from 'modules/processes/components/ItemWizard/components/Form'
import Assignees from 'modules/processes/components/ItemWizard/components/Form/Items/Assignees'
import Attachments from 'modules/processes/components/ItemWizard/components/Form/Items/Attachment'
import Deadline from 'modules/processes/components/ItemWizard/components/Form/Items/Deadline'
import Description from 'modules/processes/components/ItemWizard/components/Form/Items/Description'
import FolderSelector from 'modules/processes/components/ItemWizard/components/Form/Items/FolderSelector'
import Mandatory from 'modules/processes/components/ItemWizard/components/Form/Items/Mandatory'
import AdditionalSigner from 'modules/processes/components/ItemWizard/components/Form/Items/Signature/AdditionalSigner'
import Title from 'modules/processes/components/ItemWizard/components/Form/Items/Title'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import RequestEsignature from './Form/RequestEsignature'
import UploadSelector from './Form/UploadSelector'

const Content = () => {
  const { originalItem: item, form, initializeForm } = useFormProvider()

  useEffect(() => {
    if (item?.taskType === TaskConfigurationTypes.SignDocuments) {
      initializeForm(TaskConfigurationTypes.SignDocuments)
    } else {
      initializeForm(TaskConfigurationTypes.SendDocumentTemplate)
    }
  }, [])

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees />,
        uploadSelector: <UploadSelector />,
        folder: <FolderSelector />,
        requestEsignature: <RequestEsignature />,
        additionalSigner: <AdditionalSigner />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
